import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import THEME from 'theme';
import { Heading, Text } from 'components/chroma';

const HeadingWrapper = styled.div`
  text-align: center;
`;

const Container = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  text-align: center;
  margin: 1.5rem;
  border-top: 1px solid ${THEME.PAYMENT_CONFIRMATION_CONTAINER.BORDER};

  span {
    padding-top: 0.5rem;
    :first-of-type {
      border-right: 1px solid ${THEME.PAYMENT_CONFIRMATION_CONTAINER.BORDER};
    }
  }
`;

const PolicySummary: FunctionComponent<{
  policyNumber: string;
  policyStartDate: string;
  policyExpiryDate: string;
  productType?: string;
  headingSize?: number;
}> = ({
  policyNumber,
  policyStartDate,
  policyExpiryDate,
  productType,
  headingSize,
}) => (
  <HeadingWrapper>
    {productType && (
      <Heading size={headingSize || 6} margin={{ bottom: 2 }}>
        {productType}
      </Heading>
    )}
    <strong>Your policy: {policyNumber}</strong>
    <Container>
      <span>
        <Text margin={{ bottom: 0 }}>Policy start date</Text>
        <Text weight={700} margin={{ bottom: 1 }}>
          {policyStartDate}
        </Text>
      </span>
      <span>
        <Text margin={{ bottom: 0 }}>Policy expiry date</Text>
        <Text weight={700} margin={{ bottom: 1 }}>
          {policyExpiryDate}
        </Text>
      </span>
    </Container>
  </HeadingWrapper>
);

export default PolicySummary;
